import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'
import i18nVue from '@/i18n/locale'
// 证件类型

export default new EnumItem({
  '1': { value: 1, text: i18n.gettext('新版') },
  '2': { value: 2, text: i18n.gettext('老版无Curp') },
  '3': { value: 3, text: i18n.gettext('老版有Curp') },
  '9': { value: 9, text: i18nVue.t('FoodB_Show_ID_Card_BrxO' /** 身份证 */) },
  '10': {
    value: 10,
    text: i18nVue.t('FoodB_Show_Aliens_Residence_creU' /** 外国人居留卡 */)
  },
  '12': {
    value: 12,
    text: i18nVue.t('FoodB_Show_Foreign_DIMEX_LKxF' /** 外国人DIMEX */)
  },
  '13': { value: 13, text: i18n.gettext('护照') },
  '14': {
    value: 14,
    text: i18nVue.t('FoodB_Show_Special_residence_ezfV' /** 外国人特殊居留证 */)
  },
  '16': { value: 16, text: i18nVue.t('FoodB_Launch_DR_ID_AnVk' /** DR-身份证 */) },
  '17': { value: 17, text: i18nVue.t('FoodB_Launch_DR_Military_Rxvi' /** DR-军人证 */) },
  '18': { value: 18, text: i18nVue.t('FoodB_Launch_DR_Foreigner_gXpW' /** DR-外国人证 */) },
  '19': { value: 19, text: i18nVue.t('FoodB_Launch_DR_Temporary_BQFH' /** DR-临时居留证 */) },
  '20': { value: 20, text: i18nVue.t('FoodB_Launch_DR_Passport_JChW' /** DR-护照 */) }
})
